import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M4 13c2-3 4-4.5 8-4.5s6 1.5 8 4.5M6 13c1.5 2.5 3.5 3.8 6 3.8s4.5-1.3 6-3.8" }, null, -1),
    _createElementVNode("circle", {
      cx: "16.5",
      cy: "11",
      r: ".8",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    _createElementVNode("path", { d: "M19.5 12.5 21 11" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-reptiles"}) } }